var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2Hover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3333 9.16667L10 12.5M10 12.5L6.66667 9.16667M10 12.5V2.5M17.5 12.5V13.8333C17.5 14.9379 16.6046 15.8333 15.5 15.8333H4.5C3.39543 15.8333 2.5 14.9379 2.5 13.8333L2.5 12.5",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2Hover);
export default __webpack_public_path__ + "static/media/download-2-hover.b37854f64af8ce5e69aa30b0fc3688d3.svg";
export { ForwardRef as ReactComponent };